import { useState } from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { F0Icon } from '@factorialco/f0-react'
import { Pencil } from '@factorialco/f0-react/icons/app'

import { PayrollModal } from './Modal'

export const PayrollTitle = ({ children }: { children: React.ReactNode }) => {
  const [modalOpen, setModalOpen] = useState(false)
  const [hover, setHover] = useState(false)

  return (
    <>
      <Box
        gap="s8"
        alignItems="center"
        flexDirection="row"
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
      >
        {children}
        {hover && (
          <F0Icon
            icon={Pencil}
            size="md"
            color="grey600"
            onClick={() => setModalOpen(true)}
            cursor="pointer"
          />
        )}
      </Box>

      {modalOpen && <PayrollModal onClose={() => setModalOpen(false)} />}
    </>
  )
}
